import { Header              } from "../../main_components/header.js";
import { Loading             } from "../../main_components/loading.js";
import { GeminiBody          } from "./gemini_body.js";
import { useState, useEffect } from "react";
export const Gemini = ( props ) => {
    const { loadingDuration } = props;
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ toggle,   setToggle   ] = useState(true);
    useEffect(() => {
        window.onload = _=> setIsLoaded(true);
        setTimeout(_=> {
            setIsLoaded(true);
            setTimeout(_=>{ setToggle(false) }, 500);
            }, loadingDuration);
    }, []);
    return (
        <>
            { toggle && <Loading page={ "Gemini" } isLoaded={ isLoaded }/> }
            <Header link={ "Gemini-2.0-flash" }/>
            <GeminiBody />
        </>
    );
};